var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h1", [_vm._v("Zamówienie o id " + _vm._s(_vm.data.id))]),
      _c("h2", [_vm._v("Parametry zamówienia:")]),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { staticClass: "py-3", attrs: { md: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: { filled: "", label: "Nazwa firmy", readonly: "" },
                model: {
                  value: _vm.data.contractor_name,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "contractor_name", $$v)
                  },
                  expression: "data.contractor_name"
                }
              }),
              _c("v-text-field", {
                attrs: { filled: "", label: "Nip", readonly: "" },
                model: {
                  value: _vm.data.contractor_tin,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "contractor_tin", $$v)
                  },
                  expression: "data.contractor_tin"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "px-3", attrs: { md: "4", cols: "12" } },
            [
              _c("v-textarea", {
                staticClass: "input-capitalize",
                attrs: {
                  value: _vm.address,
                  filled: "",
                  height: "144px",
                  label: "Adres",
                  "no-resize": "",
                  readonly: "",
                  "hide-details": ""
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { md: "4", cols: "12" } },
            [
              _c("v-textarea", {
                attrs: { label: "Komentarz", outlined: "", filled: "" },
                model: {
                  value: _vm.data.service_order_comment,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "service_order_comment", $$v)
                  },
                  expression: "data.service_order_comment"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { md: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  readonly: "",
                  value: _vm.data.order_group_id,
                  filled: "",
                  label: "Id grupy zamówienia",
                  "append-outer-icon": "fa-copy"
                },
                on: {
                  "click:append-outer": function($event) {
                    return _vm.$copyText(_vm.data.order_group_id)
                  }
                }
              })
            ],
            1
          ),
          !!_vm.data.project_name && _vm.data.project_name.length > 0
            ? _c(
                "v-col",
                { staticClass: "px-2", attrs: { md: "4", cols: "12" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      readonly: "",
                      value: _vm.data.project_name,
                      filled: "",
                      label: "Atrybut projekt",
                      "append-outer-icon": "fa-copy"
                    },
                    on: {
                      "click:append-outer": function($event) {
                        return _vm.$copyText(_vm.data.project_name)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          !!_vm.data.order_number && _vm.data.order_number.length > 0
            ? _c(
                "v-col",
                { staticClass: "px-2", attrs: { md: "4", cols: "12" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      readonly: "",
                      value: _vm.data.order_number,
                      filled: "",
                      label: "Atrybut numer zamówienia",
                      "append-outer-icon": "fa-copy"
                    },
                    on: {
                      "click:append-outer": function($event) {
                        return _vm.$copyText(_vm.data.order_number)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          !!_vm.data.external_customer_name &&
          _vm.data.external_customer_name.length > 0
            ? _c(
                "v-col",
                { staticClass: "px-2", attrs: { md: "4", cols: "12" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      readonly: "",
                      value: _vm.data.external_customer_name,
                      filled: "",
                      label: "Atrybut klient",
                      "append-outer-icon": "fa-copy"
                    },
                    on: {
                      "click:append-outer": function($event) {
                        return _vm.$copyText(_vm.data.external_customer_name)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c("admin-travel-service-additional-params-preview", {
        attrs: { "additional-parameters": _vm.data.additional_parameters }
      }),
      _c(
        "p",
        { staticStyle: { "font-size": "larger" } },
        [
          _vm.data.phone_numbers != null && _vm.data.phone_numbers.length > 3
            ? _c("span", [
                _vm._v(" Telefon: " + _vm._s(_vm.data.phone_numbers)),
                _c("br")
              ])
            : _vm._e(),
          _vm.data.contractor_mail_addresses != null &&
          _vm.data.contractor_mail_addresses.length > 3
            ? _c("span", [
                _vm._v(" Email firmowy: "),
                _c(
                  "a",
                  {
                    attrs: {
                      href: "mailto:" + _vm.data.contractor_mail_addresses
                    }
                  },
                  [_vm._v(_vm._s(_vm.data.contractor_mail_addresses))]
                ),
                _c("br")
              ])
            : _vm._e(),
          _vm._v(" Utworzono: " + _vm._s(_vm.data.created_at) + " przez "),
          _c("span", { staticClass: "font-weight-bold" }, [
            _vm._v(_vm._s(_vm.data.created_by_name) + " ")
          ]),
          _vm.data.created_by_email != null &&
          _vm.data.created_by_email.length > 0
            ? _c("span", [
                _vm._v(" email zamawiającego: "),
                _c(
                  "a",
                  { attrs: { href: "mailto:" + _vm.data.created_by_email } },
                  [_vm._v(_vm._s(_vm.data.created_by_email))]
                )
              ])
            : _vm._e(),
          _vm.data.created_by_phone != null &&
          _vm.data.created_by_phone.length > 0
            ? _c("span", [
                _vm._v(", nr telefonu: "),
                _c("span", { staticClass: "font-weight-bold" }, [
                  _vm._v(_vm._s(_vm.data.created_by_phone))
                ])
              ])
            : _vm._e(),
          _vm._v(" . "),
          _c("br"),
          _vm._v(" Status zamówienia: "),
          _c("order-chip", { attrs: { status: _vm.data.status } })
        ],
        1
      ),
      _c("h2", [_vm._v("Lista zamówionych usług:")]),
      _c("v-data-table", {
        attrs: {
          headers: _vm.headers,
          items: _vm.data.items,
          "hide-default-footer": "",
          loading: _vm.$store.getters["Ajax/loading"] ? "accent" : false,
          "footer-props": {
            "items-per-page-options": [
              { text: "$vuetify.dataIterator.rowsPerPageAll", value: -1 }
            ]
          }
        },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function(props) {
              return [
                _c("tr", [
                  _c("td", [
                    _vm._v(
                      _vm._s(_vm.$t("travelService.types." + props.item.type))
                    )
                  ]),
                  _c("td", [
                    props.item.type === "hotel"
                      ? _c("span", [
                          _vm._v(
                            " Od " +
                              _vm._s(props.item.start_date) +
                              " " +
                              _vm._s(props.item.start_time) +
                              " do " +
                              _vm._s(props.item.end_date) +
                              " "
                          )
                        ])
                      : _vm._e(),
                    props.item.type === "flight"
                      ? _c("span", [
                          _vm._v(
                            " Wylot " +
                              _vm._s(props.item.start_date) +
                              " " +
                              _vm._s(props.item.start_time) +
                              " "
                          ),
                          props.item.return_date != null
                            ? _c("span", [
                                _vm._v(
                                  "Lot powrotny " +
                                    _vm._s(props.item.return_date) +
                                    " " +
                                    _vm._s(props.item.return_time)
                                )
                              ])
                            : _vm._e()
                        ])
                      : _vm._e(),
                    props.item.type === "rail"
                      ? _c("span", [
                          _vm._v(
                            " Wyjazd " +
                              _vm._s(props.item.start_date) +
                              " " +
                              _vm._s(props.item.start_time) +
                              " "
                          ),
                          props.item.return_date != null
                            ? _c("span", [
                                _vm._v(
                                  "Powrót " +
                                    _vm._s(props.item.return_date) +
                                    " " +
                                    _vm._s(props.item.return_time)
                                )
                              ])
                            : _vm._e()
                        ])
                      : _vm._e(),
                    props.item.type === "car"
                      ? _c("span", [
                          _vm._v(
                            " Od " +
                              _vm._s(props.item.start_date) +
                              " " +
                              _vm._s(props.item.start_time) +
                              " do " +
                              _vm._s(props.item.end_date) +
                              " " +
                              _vm._s(props.item.end_time) +
                              " "
                          )
                        ])
                      : _vm._e(),
                    props.item.type === "insurance"
                      ? _c("span", [
                          _vm._v(
                            " Od " +
                              _vm._s(props.item.start_date) +
                              " do " +
                              _vm._s(props.item.end_date) +
                              " "
                          )
                        ])
                      : _vm._e()
                  ]),
                  _c(
                    "td",
                    [
                      props.item.type === "hotel"
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.allRoomTypes().find(function(v) {
                                    return v.value === props.item.room_type
                                  }).text
                                ) +
                                " "
                            ),
                            _c("br"),
                            _c("b", [_vm._v(_vm._s(props.item.locationText))])
                          ])
                        : _vm._e(),
                      props.item.type === "flight"
                        ? _c("span", [
                            _vm._v(" Z "),
                            _c("b", [
                              _vm._v(_vm._s(props.item.startLocationText))
                            ]),
                            _vm._v(" do "),
                            _c("b", [
                              _vm._v(_vm._s(props.item.endLocationText))
                            ]),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" Klasa: "),
                            _c("b", [
                              _vm._v(
                                _vm._s(
                                  _vm.allFlightClassTypes().find(function(v) {
                                    return v.value === props.item.seat_class
                                  }).text
                                )
                              )
                            ])
                          ])
                        : _vm._e(),
                      props.item.type === "rail"
                        ? _c("span", [
                            _vm._v(" Z "),
                            _c("b", [
                              _vm._v(_vm._s(props.item.startLocationText))
                            ]),
                            _vm._v(" do "),
                            _c("b", [
                              _vm._v(_vm._s(props.item.endLocationText))
                            ]),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" Klasa: "),
                            _c("b", [
                              _vm._v(
                                _vm._s(
                                  _vm.allRailClassTypes().find(function(v) {
                                    return v.value === props.item.seat_class
                                  }).text
                                )
                              )
                            ])
                          ])
                        : _vm._e(),
                      props.item.type === "car"
                        ? _c("span", [
                            _vm._v(" Odbiór "),
                            _c("b", [
                              _vm._v(_vm._s(props.item.startLocationText))
                            ]),
                            props.item.endLocationText != null &&
                            props.item.endLocationText.length > 0
                              ? _c("span", [
                                  _vm._v(" zwrot "),
                                  _c("b", [
                                    _vm._v(_vm._s(props.item.endLocationText))
                                  ])
                                ])
                              : _vm._e(),
                            _c("br"),
                            _vm._v(" Klasa pojazdu: "),
                            _c("b", [
                              _vm._v(
                                _vm._s(
                                  _vm.allCarTypes().find(function(v) {
                                    return v.value === props.item.car_class
                                  }).text
                                )
                              )
                            ])
                          ])
                        : _vm._e(),
                      props.item.type === "other"
                        ? _c("span", [
                            _vm._v(" Usługa: "),
                            _c("b", [_vm._v(_vm._s(props.item.name))])
                          ])
                        : _vm._e(),
                      props.item.type === "insurance"
                        ? _c("span", [
                            _vm._v(" Lokalizacja: "),
                            _c("b", [_vm._v(_vm._s(props.item.locationText))])
                          ])
                        : _vm._e(),
                      _vm._v(" " + _vm._s(props.item.comment) + " "),
                      _c("br"),
                      _vm._v(" Dla: "),
                      _vm._l(props.item.users, function(user) {
                        return _c("span", { key: user.passenger_id }, [
                          _c("b", [
                            _vm._v(
                              _vm._s(user.name) + " " + _vm._s(user.surname)
                            )
                          ]),
                          _vm._v(", ")
                        ])
                      }),
                      !!props.item.cost_centre
                        ? [
                            _c("br"),
                            _vm._v(" MPK: "),
                            _c("b", [_vm._v(_vm._s(props.item.cost_centre))])
                          ]
                        : _vm._e()
                    ],
                    2
                  ),
                  _c(
                    "td",
                    [
                      _c("single-service-order-chip", {
                        attrs: { status: props.item.status }
                      })
                    ],
                    1
                  ),
                  _c(
                    "td",
                    [
                      [
                        _vm.itemsStatus.STATUS_CREATED,
                        _vm.itemsStatus.STATUS_ALREADY_SEND,
                        _vm.itemsStatus.STATUS_READY_TO_SEND,
                        _vm.itemsStatus.STATUS_REQUEST_CLIENT_ANSWER_FOR_OFFER
                      ].includes(props.item.status)
                        ? _c(
                            "v-tooltip",
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      return [
                                        _c(
                                          "v-btn",
                                          _vm._g(
                                            {
                                              attrs: {
                                                to:
                                                  "/admin/travel-service/item/edit/" +
                                                  props.item.id,
                                                icon: ""
                                              }
                                            },
                                            on
                                          ),
                                          [
                                            _c("v-icon", [_vm._v("assignment")])
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            },
                            [_vm._v(" Zaofertuj zamówienie ")]
                          )
                        : _vm._e(),
                      [
                        _vm.itemsStatus.STATUS_CANCELED_BY_CLIENT,
                        _vm.itemsStatus.STATUS_BOOKING_CANCELLED,
                        _vm.itemsStatus.STATUS_OFFER_SELECTED_BY_CLIENT,
                        _vm.itemsStatus.STATUS_CLIENT_REQUEST_BOOKING_CANCEL
                      ].includes(props.item.status)
                        ? _c(
                            "v-tooltip",
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      return [
                                        _c(
                                          "v-btn",
                                          _vm._g(
                                            {
                                              attrs: {
                                                to:
                                                  "/admin/travel-service/item/readonly/" +
                                                  props.item.id,
                                                icon: ""
                                              }
                                            },
                                            on
                                          ),
                                          [
                                            _c("v-icon", [_vm._v("assignment")])
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            },
                            [_vm._v(" Podgląd oferty ")]
                          )
                        : _vm._e(),
                      [
                        _vm.itemsStatus.STATUS_OFFER_ACCEPTED_BY_CLIENT,
                        _vm.itemsStatus.STATUS_BOOKED,
                        _vm.itemsStatus.STATUS_REQUEST_CLIENT_ANSWER_FOR_BOOK
                      ].includes(props.item.status)
                        ? _c(
                            "v-tooltip",
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      return [
                                        _c(
                                          "v-btn",
                                          _vm._g(
                                            {
                                              attrs: {
                                                to:
                                                  "/admin/travel-service/add-booking/" +
                                                  props.item.id,
                                                icon: ""
                                              }
                                            },
                                            on
                                          ),
                                          [
                                            _c("v-icon", [_vm._v("assignment")])
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            },
                            [_vm._v(" Dołącz rezerwację ")]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }